import { config } from '../config';
import { isValidUUID, makeApiRequest_AppJson, makeApiRequest_formData, makeApiRequest_Text } from './common-apiService';


export const fetchGitPlansData = async () => {
    const url = `${config.baseB2B_URL}/b2b/plans/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const fetchPlansDataPaged = async (accessToken, includeImages = false, page = 0, size = 10) => {
    const url = `${config.baseB2B_URL}/b2b/plans/paged?includeImages=${includeImages}&page=${page}&size=${size}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchPlanData = async (accessToken, planUUID, includeImages = false) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}?includeImages=${includeImages}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchPlanStatusTrendProgressData = async (accessToken, planUUID) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/statusTrendProgress`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const saveNewPlan = async (accessToken, plan) => {
    const url = `${config.baseB2B_URL}/b2b/plans/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, plan);
}

export const updatePlan = async (accessToken, plan) => {
    const url = `${config.baseB2B_URL}/b2b/plans/${plan.planUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, plan);
}

export const fetchPlanImagePath = async (accessToken, planUUID) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/imagePath`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_Text(url, 'GET', headers);
}

export const uploadPlanImage = async (accessToken, planUUID, imageFile) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/image`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    const formData = new FormData();
    formData.append('image', imageFile);
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const deletePlanImage = async (accessToken, planUUID) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/image`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const deletePlan = async (accessToken, planUUID) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// AREAS

export const saveNewArea = async (accessToken, planUUID, area) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, area);
}

export const fetchArea = async (accessToken, planUUID, areaId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchAreaImagePath = async (accessToken, planUUID, areaId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/imagePath`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_Text(url, 'GET', headers);
}

export const updateArea = async (accessToken, planUUID, area) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${area.areaId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, area);
}

export const deleteArea = async (accessToken, planUUID, areaId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const uploadAreaImage = async (accessToken, planUUID, areaId, imageFile) => {
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/image`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    const formData = new FormData();
    formData.append('image', imageFile);
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const deleteAreaImg = async (accessToken, planUUID, areaId) => {
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/image`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const fetchAreasCoveringDateRange = async (accessToken, startDate, endDate) => {
    const url = `${config.baseB2B_URL}/b2b/plans/areasCoveringDateRange?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchAreasNotCoveringDateRange = async (accessToken, startDate, endDate) => {
    const url = `${config.baseB2B_URL}/b2b/plans/areasNotCoveringDateRange?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

// AREA INDICATORS

export const saveNewAreaIndicator = async (accessToken, planUUID, areaId, areaIndicator) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, areaIndicator);
}

export const updateAreaIndicator = async (accessToken, planUUID, areaId, areaIndicator) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicator.areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, areaIndicator);
}

export const deleteAreaIndicator = async (accessToken, planUUID, areaId, areaIndicatorId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const copyAreaIndicator = async (accessToken, planUUID, areaId, areaIndicatorId, targetPlanUUID, targetAreaId) => {
    if (!isValidUUID(planUUID) || !isValidUUID(targetPlanUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/copy/${targetPlanUUID}/${targetAreaId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers);
}

export const moveAreaIndicator = async (accessToken, sourcePlanUUID, sourceAreaId, areaIndicatorId, targetPlanUUID, targetAreaId) => {
    if (!isValidUUID(sourcePlanUUID) || !isValidUUID(targetPlanUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${sourcePlanUUID}/${sourceAreaId}/${areaIndicatorId}/move/${targetPlanUUID}/${targetAreaId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers);
}

export const fetchAreaIndicatorSimplified = async (accessToken, planUUID, areaId, areaIndicatorId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/simplified`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchAreaIndicatorWithLoadFactor = async (accessToken, planUUID, areaId, areaIndicatorId, loadFactor) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/areaIndicator/simplified/${areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, loadFactor);
}

export const fetchOrganizationAreaIndicatorsData = async (accessToken, loadFactor=null) => {
    const url = `${config.baseB2B_URL}/b2b/plans/areaIndicator/simplified/all`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, loadFactor);
}

// OBJECTIVES

export const saveNewObjective = async (accessToken, planUUID, areaId, areaIndicatorId, objective) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/objectives/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, objective);
}

export const saveNewBulkOfObjectives = async (accessToken, planUUID, areaId, areaIndicatorId, objectives) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/objectives/newBulk`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, objectives);
}

export const updateObjective = async (accessToken, planUUID, areaId, areaIndicatorId, objective) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/objectives/${objective.objectiveId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, objective);
}

export const deleteObjective = async (accessToken, planUUID, areaId, areaIndicatorId, objectiveId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/objectives/${objectiveId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const fetchAllObjectives = async (accessToken, planUUID, areaId, areaIndicatorId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/objectives`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchObjective = async (accessToken, planUUID, areaId, areaIndicatorId, objectiveId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/objectives/${objectiveId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

// SAMPLES

export const saveNewSample = async (accessToken, planUUID, areaId, areaIndicatorId, sample) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/samples/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, sample);
}

export const updateSample = async (accessToken, planUUID, areaId, areaIndicatorId, sampleId, sample) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/samples/${sampleId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, sample);
}

export const deleteSample = async (accessToken, planUUID, areaId, areaIndicatorId, sampleId) => {
    if (!isValidUUID(planUUID)) {
        throw new Error('Invalid planUUID format');
    }
    const url = `${config.baseB2B_URL}/b2b/plans/${planUUID}/${areaId}/${areaIndicatorId}/samples/${sampleId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}